import angular from 'angular';

import _css from './od-signup.less';

module.exports = angular.module('market.component.od-signup', [
])
.component('odSignup', {
  template: require('./od-signup.jade')(),
  bindings: {
    signupType: '@', // Likely "buyer" or "seller"
    onRegistrationComplete: '&',
    // Override default behavior of button
    onAlreadyHaveAccount: '&',
    customerId: '<?',
    // Pre-fill certain fields if desired
    fullName: '<?',
    email: '<?',
    phoneNumber: '<?',
  },
  controller: class {
    constructor($rootScope, $window, Human, $transclude, Analytics) {
      this.$rootScope = $rootScope;
      this.$window = $window;
      this.Human = Human;
      this.errors = {};
      this.session = this.$rootScope.session;
      this.Analytics = Analytics;

      if (this.session.human) {
        this.onRegistrationComplete({ wasLoggedIn: true });
      }

      this.password = '';
      this.pending = false;
    }

    register() {
      this.pending = true;
      let newHuman = new this.Human({
        full_name: this.fullName,
        email: this.email,
        primary_phone: this.phoneNumber,
        password: this.password,
        signup_type: this.signupType,
      });
      newHuman.$register().then(() => {
        this.Analytics.event('signup', 'submit', 'signup-success');
        this.pending = false;
        // Fetch the latest login information
        this.session.$me().then(() => {
          this.onRegistrationComplete({ wasLoggedIn: false });
        });
      }).catch((e) => {
        this.Analytics.event('signup', 'submit', 'signup-error');
        this.pending = false;
        this.errors = e.data.errors;
      });
    }
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-signup.js
 **/